<template>
    <div class="row mt-3">
        <div class="col-md-12">
            <div class="row">
                <div class="col-md-8">
                    <h5 class="font-weight-bold">
                        Anotações sobre o não cumprimento das condicionalidades de educação no {{ $t("Bolsa Família") }}
                    </h5>
                </div>
                <div class="col-md-4 text-right">
                    <button
                        class="btn btn-sm btn-primary"
                        @click="
                            $bvModal.show('cadastrar-descumprimento-educacao')
                        "
                    >
                        <i class="fas fa-plus-square" />
                        {{ $t("Cadastrar") }}
                    </button>
                </div>
            </div>
            <div
                v-for="(usuario, index) in item.descumprimentos"
                :key="usuario.id"
            >
                <div class="p-0 col-12 mb-3" v-if="usuario.tipo == 'educacao'">
                    <table class="table table-bordered">
                        <tbody>
                            <tr class="col-12">
                                <td colspan="2">
                                    <router-link
                                        :to="
                                            '/dashboard/usuario/edit/' +
                                            usuario.id
                                        "
                                    >
                                        <strong>
                                            {{
                                                usuario.usuario_id.nome_completo
                                            }}
                                        </strong>
                                    </router-link>
                                    <br />
                                    Idade:
                                    {{ usuario.usuario_id.idade }} ano(s)<br />
                                </td>
                            </tr>
                            <tr>
                                <th>Data da ocorrência</th>
                                <td>{{ usuario.data_ocorrencia }}</td>
                            </tr>
                            <tr>
                                <th>Efeito</th>
                                <td>
                                    <span class="text-warning">{{
                                        checkEfeito(usuario.efeito)
                                    }}</span>
                                </td>
                            </tr>
                            <tr>
                                <th>Solicitada suspensão do efeito?</th>
                                <td>
                                    {{
                                        usuario.solicitada_suspensao == 1
                                            ? "Sim"
                                            : "Não"
                                    }}
                                </td>
                            </tr>
                            <tr v-if="usuario.user">
                                <td colspan="2">
                                    <div
                                        class="d-flex justify-content-between align-items-center"
                                    >
                                        <small class="text-muted d-block"
                                            >Técnico: {{ usuario.user.name }}
                                            <br />Unidade:
                                            {{
                                                usuario.user.tecnico.unidade
                                                    .nome
                                            }}</small
                                        >
                                        <b-button
                                            title="Desativar registro"
                                            @click.prevent="
                                                desativarRegistro(usuario.id)
                                            "
                                            class="px-2 mb-0 btn-excluir"
                                            size="xs"
                                            type="button"
                                            v-b-tooltip.hover
                                            v-if="
                                                usuario.user_id ==
                                                $store.state.user.id
                                            "
                                            variant="danger"
                                            data-style="zoom-in"
                                        >
                                            <i class="fas fa-fw fa-trash" />
                                        </b-button>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <div v-else>
                    <h4
                        class="text-secondary"
                        v-if="index == item.descumprimentos.length - 1"
                    >
                        <i class="mdi mdi-24px mdi-alert-decagram-outline"></i>
                        Não há informações disponíveis para visualização.
                    </h4>
                </div>
            </div>
            <div>
                <h4
                    class="text-secondary"
                    v-if="item.descumprimentos.length <= 0"
                >
                    <i class="mdi mdi-24px mdi-alert-decagram-outline"></i>
                    Não há informações disponíveis para visualização.
                </h4>
            </div>
        </div>
        <ModalCadastrarDescumprimento :item="item" />
    </div>
</template>
<script>
import ModalCadastrarDescumprimento from "./ModalCadastrarDescumprimento";
export default {
    components: { ModalCadastrarDescumprimento },
    props: ["item"],
    data() {
        return {};
    },
    methods: {
        submit() {},
        checkEfeito(efeito) {
            const result = this.$root.arrays.efeito_descumprimento.filter(
                (item) => item.id == efeito
            );
            return result ? result[0].value : "";
        },
        desativarRegistro(id) {
            let ladda = Ladda.create(document.querySelector(".btn-excluir"));
            ladda.start();
            swal.fire({
                title: this.$t("Are you sure?"),
                text: "O registro será desativado e não aparecerá na listagem de dados",
                showCancelButton: true,
                cancelButtonText: this.$t("Cancel"),
                confirmButtonText: this.$t("Delete"),
                icon: "warning",
            }).then((value) => {
                if (value.isConfirmed) {
                    axios
                        .put(
                            "api/dashboard/familias/descumprimentoupdate/" + id,
                            {
                                status: 2,
                            }
                        )
                        .then((response) => {
                            this.$snack.success({
                                button: false,
                                text: "Registro desativado com sucesso!",
                            });

                            this.item.descumprimentos = response.data;
                        })
                        .catch(() => {
                            ladda.stop();
                        });
                }
            });
        },
    },
};
</script>
